var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSources = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "26pt",
    height: "26pt",
    className: "fill",
    viewBox: "0 0 36.992 37.029",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 26.207c1.662 0 3.024 1.322 3.024 2.985 0 1.625-1.362 2.985-3.024 2.985-1.7 0-3.023-1.36-3.023-2.985 0-1.663 1.323-2.985 3.023-2.985m0-1.815c-2.722 0-4.875 2.116-4.875 4.8 0 2.645 2.153 4.8 4.875 4.8 2.684 0 4.876-2.155 4.876-4.8 0-2.684-2.192-4.8-4.876-4.8M4.813 4.89c14.627.869 26.382 12.623 27.288 27.287h-2.948C28.247 19.14 17.853 8.707 4.813 7.8zM3 3v6.576c13.455 0 24.377 10.961 24.377 24.416h6.615C33.992 16.871 20.082 3 3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.852 15.095c9.108.869 16.365 8.088 17.235 17.121H19.1c-.83-7.408-6.765-13.304-14.248-14.173zm-1.815-1.891v6.577c7.899 0 14.363 6.35 14.363 14.248h6.613c0-11.489-9.448-20.825-20.976-20.825"
  })));
};
export default SvgSources;